import prettyBytes from "pretty-bytes";

export const transformBytes = (bytes: string | number) => {
  return prettyBytes(Number(bytes) * 1000000);
};
